// The tutorial's first step: a new trainer chooses their name (free, once).
// Sign-up makes the account under a stand-in name (server/auth.ts pendingName);
// until this is done the hunt waits and the starter choice comes next.
import { S } from './state.ts';
import type { ClientMsg } from '../shared/protocol.ts';

const NAME_RE = /^[A-Za-z0-9_]{3,16}$/;
let host: HTMLElement | null = null;

function suggestion(): string {
  try { return (localStorage.getItem('mi-name-suggest') ?? '').replace(/[^A-Za-z0-9_]/g, '').slice(0, 16); } catch { return ''; }
}

export function renderNamePick(send: (m: ClientMsg) => void) {
  const want = !!S.trainer?.namePick;
  // The stand-in name never shows: the places that print your own name stay blank until you choose.
  if (document.documentElement.classList.contains('np-on') !== want) document.documentElement.classList.toggle('np-on', want);
  if (!want) {
    if (host) { host.remove(); host = null; try { localStorage.removeItem('mi-name-suggest'); } catch { /* storage off */ } }
    return;
  }
  if (host) { host.querySelector('button')!.disabled = false; return; }
  host = document.createElement('div');
  host.className = 'scrim sp-scrim';
  host.innerHTML = `<form class="dialog np-pick" role="dialog" aria-modal="true" aria-labelledby="np-title">
    <h3 id="np-title">Choose your name</h3>
    <input name="name" maxlength="16" autocomplete="username" spellcheck="false" required aria-label="Trainer name" placeholder="Trainer name">
    <div class="err" role="alert"></div>
    <div class="actions"><button class="btn gold">Continue</button></div>
  </form>`;
  const form = host.querySelector('form')!;
  const input = form.querySelector('input')!;
  const err = form.querySelector<HTMLElement>('.err')!;
  input.value = suggestion();
  input.oninput = () => { err.textContent = ''; };
  form.onsubmit = (e) => {
    e.preventDefault();
    const name = input.value.trim();
    if (!NAME_RE.test(name)) { err.textContent = '3 to 16 letters, numbers or underscores.'; return; }
    form.querySelector('button')!.disabled = true;
    send({ t: 'namePick', name });
  };
  document.body.appendChild(host);
  input.focus();
}
